const RootscopeInjectableFactory = ($injector) => {
    return $injector.get("$rootScope");
};

export const RootscopeServiceProvider = {
    provide: "$rootScope",
    useFactory: RootscopeInjectableFactory,
    deps: ["$injector"],
};
